<template>
  <section id="privacy-policy" class="background position-relative w-100 py-5">
    <b-container class="my-3">
      <h1>{{ $t('privacyPolicy.main.tags.title') }}</h1>
    </b-container>
    <!-- eslint-disable vue/no-v-html -->
    <b-container v-html="$t('privacyPolicy.main.tags.mainDescription')"> </b-container>
    <b-container>
      <h3 dir="ltr" class="mt-3">{{ $t('privacyPolicy.main.tags.subtitle0') }}</h3>
      <p dir="ltr">
        {{ $t('privacyPolicy.main.tags.description0') }}
      </p>
      <p dir="ltr">
        {{ $t('privacyPolicy.main.tags.description1') }}
      </p>

      <h3 dir="ltr">{{ $t('privacyPolicy.main.tags.subtitle1') }}</h3>
      <p dir="ltr">
        {{ $t('privacyPolicy.main.tags.description2') }}
      </p>
      <p dir="ltr">
        {{ $t('privacyPolicy.main.tags.description3') }}
      </p>
      <p dir="ltr">
        {{ $t('privacyPolicy.main.tags.description4') }}
      </p>
      <p dir="ltr">
        {{ $t('privacyPolicy.main.tags.description5') }}
      </p>

      <h3 dir="ltr">{{ $t('privacyPolicy.main.tags.subtitle2') }}</h3>
      <p dir="ltr">
        {{ $t('privacyPolicy.main.tags.description6') }}
      </p>
      <p dir="ltr">
        {{ $t('privacyPolicy.main.tags.description7') }}
      </p>

      <h3 dir="ltr">{{ $t('privacyPolicy.main.tags.subtitle3') }}</h3>
      <p dir="ltr">
        {{ $t('privacyPolicy.main.tags.description8') }}
      </p>

      <h3 dir="ltr">{{ $t('privacyPolicy.main.tags.subtitle4') }}</h3>
      <p dir="ltr">
        {{ $t('privacyPolicy.main.tags.description9') }}
      </p>

      <h3 dir="ltr">{{ $t('privacyPolicy.main.tags.subtitle5') }}</h3>
      <p dir="ltr">
        {{ $t('privacyPolicy.main.tags.description10') }}
      </p>
      <p dir="ltr">
        {{ $t('privacyPolicy.main.tags.description11') }}
      </p>
      <p dir="ltr">
        {{ $t('privacyPolicy.main.tags.description12') }}
        <br />
        {{ $t('privacyPolicy.main.tags.description13') }}
      </p>
      <!-- eslint-disable vue/no-v-html -->
      <b-container v-html="$t('privacyPolicy.main.tags.description14')"> </b-container>

      <h3 dir="ltr">{{ $t('privacyPolicy.main.tags.subtitle6') }}</h3>
      <p dir="ltr">
        {{ $t('privacyPolicy.main.tags.description15') }}
      </p>
      <p dir="ltr">
        {{ $t('privacyPolicy.main.tags.description16') }}
      </p>
      <p dir="ltr">
        {{ $t('privacyPolicy.main.tags.description17') }}
      </p>
      <p dir="ltr">
        {{ $t('privacyPolicy.main.tags.description18') }}
      </p>
      <p dir="ltr">
        {{ $t('privacyPolicy.main.tags.description19') }}
      </p>

      <h3 dir="ltr">{{ $t('privacyPolicy.main.tags.subtitle7') }}</h3>
      <p dir="ltr">
        {{ $t('privacyPolicy.main.tags.description20') }}
      </p>
      <p dir="ltr">
        {{ $t('privacyPolicy.main.tags.description21') }}
      </p>

      <h3 dir="ltr">{{ $t('privacyPolicy.main.tags.subtitle8') }}</h3>
      <p dir="ltr">
        {{ $t('privacyPolicy.main.tags.description22') }}
      </p>
      <p dir="ltr">
        {{ $t('privacyPolicy.main.tags.description23') }}
      </p>
      <p dir="ltr">
        {{ $t('privacyPolicy.main.tags.description24') }}
      </p>

      <h3 dir="ltr">{{ $t('privacyPolicy.main.tags.subtitle9') }}</h3>
      <p dir="ltr">
        {{ $t('privacyPolicy.main.tags.description25') }}
      </p>

      <h3 dir="ltr">{{ $t('privacyPolicy.main.tags.subtitle10') }}</h3>
      <p dir="ltr">
        {{ $t('privacyPolicy.main.tags.description26') }}
      </p>

      <h3 dir="ltr">{{ $t('privacyPolicy.main.tags.subtitle11') }}</h3>
      <p dir="ltr">
        {{ $t('privacyPolicy.main.tags.description27') }}
      </p>

      <h3 dir="ltr">{{ $t('privacyPolicy.main.tags.subtitle12') }}</h3>
      <p dir="ltr">
        {{ $t('privacyPolicy.main.tags.description28') }}
      </p>

      <h3 dir="ltr">{{ $t('privacyPolicy.main.tags.subtitle13') }}</h3>
      <p dir="ltr">
        {{ $t('privacyPolicy.main.tags.description29') }}
      </p>
      <b-container v-html="$t('privacyPolicy.main.tags.description30')"> </b-container>

      <h3 dir="ltr">{{ $t('privacyPolicy.main.tags.subtitle14') }}</h3>
      <p dir="ltr">
        {{ $t('privacyPolicy.main.tags.description31') }}
      </p>
    </b-container>
  </section>
</template>

<script>
export default {
  name: 'PrivacyPolicy',
  nuxtI18n: {
    paths: {
      en: '/privacy-policy',
      de: '/datenschutzerklaerung',
      es: '/politica-de-privacidad',
      pt: '/politica-de-privacidade'
    }
  },
  head() {
    const i18nSeo = this.$seoPlugin({ slash: true });
    return {
      link: [...i18nSeo.link]
    };
  }
};
</script>

<style lang="scss" scoped>
#privacy-policy {
  .background {
    z-index: 2;
    background: white;
  }
  h1 {
    font-size: 2rem;
  }

  h3 {
    margin: 18px 0;
    font-size: 1.1rem;
  }
  p,
  li {
    color: #333;
    font-weight: 400;
    font-size: 15px;
  }
}
</style>
